"use client"
import React, { useState, useEffect } from "react";

import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

import "@/components/communities/CommunityAccoladeBadge.css";

var moment = require("moment");

const CommunityAccoladeBadge = ({
  accolade,
  small,
  tiny,
  enableHover,
  onClick,
  disabled
}) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });
  const [theAccolade, setTheAccolade] = useState(null);

  useEffect(() => {
    if (accolade) {
      setTheAccolade(accolade);
    }
  }, [accolade]);

  const markup = (
    <div
      id={`accolade-${(theAccolade && theAccolade.id) ?? "new"}`}
      key={`accolade-${(theAccolade && theAccolade.id) ?? "new"}`}
      className={`accolade-badge ${tiny ? "tiny" : small ? "sm" : "lg"} ${
        onClick ? "clickable" : ""
      } ${disabled ? "disabled" : ""}`}
      onClick={onClick}
    >
      <div
        className={`accolade-icon ${theAccolade ? theAccolade.mdIconRef : ""}`}
        style={{ color: `#${theAccolade ? theAccolade.hexColor : "090B0B"}` }}
      >
        <i className={`fas ${theAccolade ? theAccolade.mdIconRef : ""}`}></i>
      </div>
    </div>
  );

  const popover = () => (
    <Tooltip id={`tooltip-${theAccolade.id}`}>{theAccolade.name}</Tooltip>
  );

  if (theAccolade) {
    return (
      <>
        {enableHover && (
          <>
            <OverlayTrigger
              trigger={isSm ? "click" : ["hover", "focus"]}
              id="accolade-trigger"
              placement="bottom"
              overlay={popover()}
            >
              {markup}
            </OverlayTrigger>
          </>
        )}
        {!enableHover && <>{markup}</>}
      </>
    );
  } else {
    return <></>;
  }
};
export default CommunityAccoladeBadge;
